import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { MessageDisplayModel } from '../message/messageDisplay.model';

@Injectable()
export class MessageDisplayService {

   private hasSentMessage: boolean = false;
  private messageSubject: BehaviorSubject<MessageDisplayModel> = new BehaviorSubject(null);
  public message$: Observable<MessageDisplayModel> = this.messageSubject.asObservable();

  private ERROR = {
    NO_LOANS_LOOKUP_FOUND: 'Loan Number was not found. Please try again.',
    NO_LOANS_FOUND: 'No loans were found using the search criteria you entered. Please try again.',
    // EXPIRED_SESSION: 'Your session has timed out.',
    // LOCKED: `Access Denied. Your account is locked. Please contact Customer Care at ${CUSTOMER_SERVICE_NUMBER} for further assistance.`,
    // NO_SESSION: 'An unexpected error has occurred. Your session is invalid. Please log in again.',
    // PASSWORDCHANGED_FAIL: 'You cannot reuse your previous password. Please choose a different password.',
    // CHALLENGE_REQUIRED: 'Your answer was incorrect. Please try again.',
    GENERIC_PROBLEM: `A problem occurred with this transaction.`,
    DOCUMENT_ERROR: `Unable to retrieve document.  Please try again.`,
    DOCUMENT_ERROR_MANY: `Document cannot be retrieved, contact your Arvest Relationship Manager for further assistance`,
    DOCUMENT_TOO_LARGE: `File size is greater than 100mb, contact your Arvest Relationship Manager to retrieve file.`
    // NO_ACTIVE_PLAN_STATUS: 'There is currently no active plan status available.',
    // NO_HARDSHIP_STATUS_INFO: 'There is currently no hardship status information available on this loan.',
    // LOAN_INELIGIBLE_FOR_HARDSHIP_STATUS: 'This loan is not eligible for hardship assistance.',
    // LOAN_CURRENTLY_HAS_PLAN: 'This loan currently has a plan or request in progress.',
    // FORGOT_PASSWORD_PERSONAL_INFO: `Some or all of the information you entered is invalid. Please contact Customer Care at ${CUSTOMER_SERVICE_NUMBER} for help.`,
    // NO_MATCHING_ACCOUNT: `Could not find matching account. Please contact Customer Care at ${CUSTOMER_SERVICE_NUMBER} for more information.`,
   //  ACCOUNT_EXISTS: 'Account already exists',
    // INELIGIBLE_FOR_ONLINE_PAYMENTS: `Payments may not be made online for this loan. Please contact Customer Care at ${CUSTOMER_SERVICE_NUMBER} for more information.`,
    // PASSWORD_INCORRECT: 'Password incorrect',
    // PASSWORD_SAME: 'You cannot reuse your previous password. Please choose a different password.',
    // ALL_HISTORY_WARNING: 'Viewing all history may take additional processing time',
    // CANNOT_PROCESS: `We cannot process your payment request at this time. Please contact Customer Care at ${CUSTOMER_SERVICE_NUMBER}.`
  };

  private SUCCESS = {
    // NEW_PASSWORD: 'You may now log in with your new password.',
    // REQUEST_SUBMITTED: 'Your request was submitted',
    // COUPON_BOOK_ORDERED: 'Your coupon book has been ordered',
    // SIGNED_UP_FOR_AUTO_DRAFT: 'You have been signed up for auto-draft.',
    // SUBMITTED_CHANGES_FOR_AUTO_DRAFT: 'Your changes have been submitted.',
    // PAYOFF_REQUEST_SUBMITTED: 'The payoff request has been submitted. Please allow 3 to 5 business days to process this request.',
    // REQUEST_LENDING_INFO_SUBMITTED: 'Thanks for letting us know you want to speak with one of our Loan Officers. You\'ll be hearing from us soon!',
    // PASSWORD_UPDATED: 'Your password has been updated successfully.',
    // ENROLLMENT_COMPLETED: 'Thank you for signing up! Please log in to view your account.'
  };

  private PASSIVE = {
    // SAME_DAY_CREDIT: 'Payments must be processed by 8:00 PM CST for same day credit.',
    // EDITING_PAYMENT: 'Editing payment tracking number 1234567.',
    // DOES_NOT_REQUIRE_COUPON_BOOKS: 'This loan uses a payment method that does not require coupon books.',
    // HAS_PENDING_TRANSFER: 'This loan is not currently eligible for ACH enrollment due to a pending transfer. Please contact Customer Care for more information.',
    // HAS_BIWEEKLY_PAYMENTS: 'Your loan is set up for bi-weekly payments.',
    // HAS_PAYMENT_STOP: 'Automatic Draft information may not be modified on this loan. Please contact Customer Care for more information.',
    // HAS_DRAFT_REQUEST: 'You have recently requested auto draft. Once your request has been completed, you will be able to modify your settings here.',
    // HAS_ACH: HAS_ACH,
    // PAID_OFF: 'This account has been paid off.',
    // HAS_STOP_REQUEST: 'A request to stop drafting on this loan is in progress.',
    // CANNOT_BE_SET_UP_FOR_ACH: 'This loan cannot be set up for ACH.'
  };

  public sendErrorMessage(state: string): void {
    this.messageSubject.next(this.createErrorMessageDisplay(state));
    this.hasSentMessage = true;
  }

  public sendSuccessMessage(state: string): void {
    this.messageSubject.next(this.createSuccessMessageDisplay(state));
    this.hasSentMessage = true;
  }

  public sendPassiveMessage(state: string): void {
    this.messageSubject.next(this.createPassiveMessageDisplay(state));
    this.hasSentMessage = true;
  }

  public clearMessage(): void {
    this.messageSubject.next(null);
    this.hasSentMessage = false;
  }

  public hasMessage(): boolean {
    return this.hasSentMessage;
  }

  public createErrorMessageDisplay(state: string): MessageDisplayModel {
    return new MessageDisplayModel(true, this.ERROR[state], 'error');
  }

  public createSuccessMessageDisplay(state: string): MessageDisplayModel {
    return new MessageDisplayModel(true, this.SUCCESS[state], 'success');
  }
  public createPassiveMessageDisplay(state: string): MessageDisplayModel {
    return new MessageDisplayModel(true, this.PASSIVE[state], 'passive');
  }

  public createPassiveMessageDisplayWithGivenMessage(givenMessage: string): MessageDisplayModel {
    return new MessageDisplayModel(true, givenMessage, 'passive');
  }

  public createSuccessMessageDisplayWithGivenMessage(givenMessage: string): MessageDisplayModel {
    return new MessageDisplayModel(true, givenMessage, 'success');
  }

  public createErrorMessageDisplayWithGivenMessage(givenMessage: string): MessageDisplayModel {
    return new MessageDisplayModel(true, givenMessage, 'error');
  }
}
